<template>
  <div
    v-if="loadedAllVisits"
    id="data-list-list-view"
    class="data-list-container"
  >
    <!-- <div class="visit-meta">
      <h3>Venue overview</h3>
      <vs-chip color="primary" class="ml-4"
        >{{ venues.length }} venue(s)</vs-chip
      >
    </div> -->
    <vs-table
      ref="table"
      class="mt-8"
      v-model="selected"
      pagination
      :max-items="itemsPerPage"
      search
      :data="venuesOrdered"
      @selected="onClicked(selected.venueId)"
    >
      <div
        slot="header"
        class="flex flex-wrap-reverse items-center flex-grow justify-between"
      >
        <div
          class="flex flex-wrap-reverse items-center data-list-btn-container"
        >
          <!-- ADD NEW -->
          <!--<div @click="$router.push({ name: 'admin-add-new-survey', params: { surveyType: 0, formattedSurveyType: 'Survey' } }).catch(() => {})" class="btn-add-new p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-primary border border-solid border-primary">
              <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
              <span class="ml-2 text-base text-primary">Add new Survey</span>
          </div>-->
        </div>

        <!-- ITEMS PER PAGE -->
        <vs-dropdown
          vs-trigger-click
          class="cursor-pointer mb-4 mr-4 items-per-page-handler"
        >
          <div
            class="
              p-4
              border border-solid
              d-theme-border-grey-light
              rounded-full
              d-theme-dark-bg
              cursor-pointer
              flex
              items-center
              justify-between
              font-medium
            "
          >
            <span class="mr-2"
              >{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} -
              {{
                venuesOrdered.length - currentPage * itemsPerPage > 0
                  ? currentPage * itemsPerPage
                  : venuesOrdered.length
              }}
              of {{ queriedItems }}</span
            >
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
          <vs-dropdown-menu>
            <vs-dropdown-item @click="itemsPerPage = 10">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 20">
              <span>20</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 40">
              <span>40</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 100">
              <span>100</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <template slot="thead">
        <vs-th sort-key="name">Venue</vs-th>
        <vs-th sort-key="numberOfVisits">Number of visits</vs-th>
        <vs-th sort-key="status">Last completed visit</vs-th>
        <vs-th sort-key="lastVisit">Last Visit By</vs-th>
      </template>

      <template slot-scope="{ data }">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>
              <p class="product-name font-medium truncate">
                {{ tr.name }}
              </p>
            </vs-td>

            <vs-td>
              <p class="product-category">
                {{ allVisits[tr.venueId].length }}
              </p>
            </vs-td>
            <vs-td>
              <vs-chip
                :color="
                  lastVisitOlderThan(14, tr.venueId) ? 'danger' : 'success'
                "
                class="product-order-status"
                >{{ lastCompletedVisitDate(tr.venueId) }}</vs-chip
              >
            </vs-td>
            <vs-td>
              <p class="product-category">
                {{
                  allVisits[tr.venueId].length > 0
                    ? user(allVisits[tr.venueId][0].userId).firstName +
                      " " +
                      user(allVisits[tr.venueId][0].userId).lastName
                    : "N/A"
                }}
              </p>
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import moment from "moment";
import _ from "lodash";

export default {
  components: {},
  data() {
    return {
      moment,
      selected: [],
      itemsPerPage: 100,
      isMounted: false,
    };
  },
  computed: {
    ...mapGetters({
      allVisits: "venues/allVisits",
      venues: "venues/venues",
      activeVenue: "venues/activeVenue",
      user: "users/user",
      loadedAllVisits: "venues/loadedAllVisits",
    }),
    currentPage() {
      if (this.isMounted && this.loadedAllVisits && this.$refs.table) {
        return this.$refs.table.currentx;
      }
      return 0;
    },

    venuesOrdered: function () {
      return _.sortBy(this.venues, (v) =>
        this.allVisits[v.venueId].length > 0
          ? moment(this.allVisits[v.venueId][0].completedOn)
          : moment("1990-01-06T12:10:28.3172487Z")
      ).reverse();
    },

    queriedItems() {
      return this.$refs.table
        ? this.$refs.table.queriedResults.length
        : this.venuesOrdered.length;
    },

    loading() {
      return (
        this.$store.state.venues.loading || this.$store.state.venues.allLoading
      );
    },
  },
  methods: {
    async onClicked(venueId) {
      this.activeVenue = this.$store.getters["venues/activeVenue"];
      this.switchVenue(venueId);
    },
    lastVisitOlderThan(days, venueId) {
      const oldDate = moment().subtract(days, "day");
      if (this.allVisits[venueId].filter((v) => v.status === 3).length > 0) {
        return moment(this.allVisits[venueId][0].completedOn).isSameOrBefore(
          oldDate
        );
      } else {
        return true;
      }
    },
    lastCompletedVisitDate(venueId) {
      return this.allVisits[venueId].filter((v) => v.status === 3).length > 0
        ? moment(this.allVisits[venueId][0].completedOn).fromNow()
        : "Never";
    },
  },
  created() {
    this.$store.dispatch("venues/ensureAllVisits");
  },
  mounted() {
    this.isMounted = true;
  },
};
</script>

<style lang="scss">
.visit-meta {
  display: flex;
}
</style>